import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Stepper/Stepper.tsx
import { forwardRef } from "react";
import { clsx } from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "div";
var Stepper = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "className"]);
  if (!children) {
    return null;
  }
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
    ref,
    className: clsx("pd:stepper", className)
  }, rest), {
    children
  }));
});
var Stepper_default = Stepper;
export { Stepper_default };